<template>
	<div id="app_eduIndex">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body" style="position: relative;">
				<div v-if="logout" v-on:click="screen()"><dv-decoration-9 :color="['#55ffff', '#0090ff']"
						class="full_screen">{{ screenName }}</dv-decoration-9></div>
				<!-- 第一行标题装饰条 -->
				<div class="d-flex jc-center title_bg">
					<div class="title">
						<span class="title-text">&#9658; {{ title }}</span>
					</div>
				</div>
				<div class="set_btn" v-if="settingBtn">
					<div class="set_btn_img" @click="settingFlag = !settingFlag"><img src="../../assets/img/set_icon.png"> 设置</div>
					<div class="set_open" ref="settingDorm" v-show="settingFlag">
						<ul>
							<li><input type="checkbox" id="check1" value="2096" v-model="checkVal" @change="checkClick()"><label for="check1"> 辖区概况</label></li>
							<li><input type="checkbox" id="check2" value="2104" v-model="checkVal" @change="checkClick()"><label for="check2"> 校园安防</label></li>
							<li><input type="checkbox" id="check3" value="2097" v-model="checkVal" @change="checkClick()"><label for="check3"> 学生发展</label></li>
							<li><input type="checkbox" id="check4" value="2102" v-model="checkVal" @change="checkClick()"><label for="check4"> 课后服务</label></li>
							<li><input type="checkbox" id="check5" value="2103" v-model="checkVal" @change="checkClick()"><label for="check5"> 三个课堂</label></li>
							<li><input type="checkbox" id="check6" value="9999" v-model="checkVal" @change="checkClick()"><label for="check6"> 学生报名</label></li>
						</ul>
					</div>
				</div>
				<!-- 数据开始 -->
				<div class="body-box">
					<ul>
						<li :class="display1" @click="gotoModule('/dataView/area')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">辖区概况</div>
							<img class="indexblock_img" src="../../assets/img/gaikaung.jpg">
						</li>
						<li :class="display2" @click="gotoModule('/dataView/security')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">校园安防</div>
							<div class="indexblock_img"><img src="../../assets/img/xyaf.jpg"></div>
						</li>
						<li :class="display3" @click="gotoModule('/dataView/quality')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">学生发展</div>
							<img class="indexblock_img" src="../../assets/img/zongping.jpg">
						</li>
						<li :class="display4" @click="gotoModule('/dataView/clubClass')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">课后服务</div>
							<img class="indexblock_img" src="../../assets/img/kehou.jpg">
						</li>
						<li :class="display5" @click="gotoModule('/dataView/threeClass')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">三个课堂</div>
							<img class="indexblock_img" src="../../assets/img/sgkt.jpg">
						</li>
						<li :class="display6" @click="gotoModule('eduYx')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">学生报名</div>
							<img class="indexblock_img" src="../../assets/img/xsbm.jpg">
						</li>
					</ul>
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
import router from "../../router";
var storage = window.localStorage;
var region = storage.getItem("region");
export default {
	data() {
		return {
			loading: true,
			title: '',
			settingBtn: false,
			settingFlag: false,
			settingDorm: null,
			screenName: '退出',
			logout: true,
			checkVal: [],
			display1: "hidden",
			display2: "hidden",
			display3: "hidden",
			display4: "hidden",
			display5: "hidden",
			display6: "hidden"
		};
	},
	mounted() {
		this.cancelLoading();
		this.initData();
	},
	watch: {
		settingFlag: {
			handler(newVal, olVal) {
				console.log(olVal);
				if (newVal) {
					setTimeout(() => {
						document.addEventListener('click', this.settingCheck);
					}, 0);
				} else {
					document.removeEventListener('click', this.settingCheck);
				}
			}
		}
	},
	unmounted() {
		document.removeEventListener('click', this.settingCheck);
	},
	methods: {
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		// 下拉菜单选择显示模块
		settingCheck(event) {
			let dom = this.$refs.settingDorm;
			if (!dom.contains(event.target)) {
				if (this.settingFlag) {
					this.settingFlag = false;
					document.removeEventListener('click', this.settingCheck);
				}
			}
		},
		initData() {
			let _this = this;
			this.$http.get("/dataView/getNameByRedion?regionId=" + region).then(res => {
				if (res.data.code === 200) {
					_this.title = res.data.result + '教育局';
				}
			});
			//判断模块权限
			var userId = _this.$route.query.userId;
			if (userId) {
				if (userId == 'admin') {
					_this.settingBtn = true;
				} else {
					_this.settingBtn = false;
				}
				_this.logout = true;
				_this.screenName = "退出";
			} else {
				_this.logout = false;
				_this.screenName = "";
			}
			this.$http.get("/dataView/edu/getLoginMenu?regionId=" + region).then(res => {
				if (res.data.code === 200) {
					var menus = res.data.result.remark1;
					if (menus.indexOf("2096") != -1) {
						_this.display1 = "show";
						_this.checkVal.push('2096');
					}
					if (menus.indexOf("2104") != -1) {
						_this.display2 = "show";
						_this.checkVal.push('2104');
					}
					if (menus.indexOf("2097") != -1) {
						_this.display3 = "show";
						_this.checkVal.push('2097');
					}
					if (menus.indexOf("2102") != -1) {
						_this.display4 = "show";
						_this.checkVal.push('2102');
					}
					if (menus.indexOf("2103") != -1) {
						_this.display5 = "show";
						_this.checkVal.push('2103');
					}
					if (menus.indexOf("9999") != -1) {
						_this.display6 = "show";
						_this.checkVal.push('9999');
					}
				}
			});
		},
		checkClick() {
			let _this = this;
			this.$http.get("/dataView/edu/saveLoginMenu?regionId=" + region + "&menus=" + this.checkVal.join(",")).then(res => {
				if (res.data.code === 200) {
					if (_this.checkVal.indexOf("2096") != -1) {
						_this.display1 = "show";
					} else {
						_this.display1 = "hidden";
					}
					if (_this.checkVal.indexOf("2104") != -1) {
						_this.display2 = "show";
					} else {
						_this.display2 = "hidden";
					}
					if (_this.checkVal.indexOf("2097") != -1) {
						_this.display3 = "show";
					} else {
						_this.display3 = "hidden";
					}
					if (_this.checkVal.indexOf("2102") != -1) {
						_this.display4 = "show";
					} else {
						_this.display4 = "hidden";
					}
					if (_this.checkVal.indexOf("2103") != -1) {
						_this.display5 = "show";
					} else {
						_this.display5 = "hidden";
					}
					if (_this.checkVal.indexOf("9999") != -1) {
						_this.display6 = "show";
					} else {
						_this.display6 = "hidden";
					}
				}
			});
		},
		gotoModule(path) {
			var userId = this.$route.query.userId;
			var userAccount = "dataView_Cs.008009_" + region;
			if (userId) {
				if (path == 'eduYx') {
					window.open(this.$baseURL + "/dataView/gotoEduYxMain?userAccount=" + userAccount, "_blank");
				} else {
					if (router.mode == 'hash') {
						window.open("http://" + window.location.host + "?area=" + region + "#" + path + "?type=window", "_blank");
					} else {
						window.open(path + "?area=" + region + "&type=window", "_blank");
					}
				}
			} else {
				if (path == 'eduYx') {
					window.open(this.$baseURL + "/dataView/gotoEduYxMain?userAccount=" + userAccount, "_self");
				} else {
					if (path == '/dataView/threeClass') {
						window.AndroidWebView.openEduThreeClass(region);
					} else if (path == '/dataView/security') {
						window.AndroidWebView.openEduSecurity(region);
					} else {
						this.$router.push({ path: path, query: { area: region, type: 'android' } });
					}
				}
			}
		},
		screen() {
			this.$router.push({ path: '/dataView/login', query: { area: region } });
		}
	},
	// 注意在vue实例销毁前，清除我们的定时器。
	destroyed() {

	}
};
</script>

<style lang="scss">
#app_eduIndex {
	background-color: #181b37;
	width: 100%;
	min-height: 100vh;
	background-image: url("../../assets/img/after_bg.jpg");
	background-size: 100% 100%;

	.full_screen {
		width: 0.8rem;
		height: 0.8rem;
		position: absolute;
		top: 0.32rem;
		right: 0.5rem;
		font-size: 0.2rem;
		color: #55ffff;
		font-weight: bold;
		-webkit-background-clip: text;
		background-image: linear-gradient(90deg, #55ffff, #55aaff);
		-webkit-text-fill-color: transparent;
		cursor: pointer;
	}

	.bg {
		padding: 0.2rem 0.2rem 0 0.2rem;
		background-position: center center;
	}

	.title_bg {
		width: 100%;
		height: 8vh;
		background: url("../../assets/img/indextit_bg.png") center no-repeat;

		.title {
			width: 100%;
			text-align: left;

			.title-text {
				display: inline-block;
				font-size: 0.25rem !important;
				font-weight: bold;
				line-height: 0.25rem;
				margin-left: 0;
				margin-top: 0.25rem;
				background-image: linear-gradient(135deg, #55ffff, #54c3ff);
				-webkit-background-clip: text;
				color: transparent;
			}
		}
	}

	//下方区域的布局
	.body-box {
		width: 100%;
		height: 92vh;
		margin-top: -0.2rem;
		overflow: hidden;
	}

	.body-box ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		height: 100%;
		box-sizing: border-box;
	}

	.body-box ul li {
		width: 31.3%;
		height: 42.5vh;
		margin: 0.2rem 1% 0;
		position: relative;
		cursor: pointer;
	}

	.indexblock_bgimg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}

	.indexblock_img {
		width: 95%;
		height: 70%;
		border-radius: 0.1rem;
		position: absolute;
		top: 18%;
		left: 4%;
	}

	.indexblock_bgimg img,
	.indexblock_img img {
		width: 100%;
		height: 100%;
	}

	.indexblock_tit {
		font-size: 0.25rem;
		font-weight: bold;
		background-image: linear-gradient(135deg, #55ffff, #54c3ff);
		-webkit-background-clip: text;
		color: transparent;
		position: absolute;
		top: 0.28rem;
		left: 0.8rem;
	}

	.indexblock_click {
		display: inline-block;
		font-size: 0.2rem;
		font-weight: bold;
		background-image: linear-gradient(135deg, #55ffff, #54c3ff);
		-webkit-background-clip: text;
		color: transparent;
		position: absolute;
		bottom: 0.1rem;
		right: 0.45rem;
	}

	.indexblock_click:hover {
		cursor: pointer;
	}

	.show {
		display: block;
	}

	.hidden {
		display: none;
	}

	.set_btn {
		color: #00a6ff;
		font-size: 0.2rem;
		cursor: pointer;
		position: absolute;
		right: 2.22rem;
		top: 0.6rem;
		border: 1px dotted #0084ff;
		box-shadow: 0px 0px 10px #0084ff inset;
		border-radius: 0.01rem;
	}

	.set_btn .set_btn_img {
		padding: 0.05rem 0.3rem 0.1rem;
	}

	.set_btn img {
		width: 0.2rem;
		vertical-align: middle;
	}

	.set_open {
		cursor: pointer;
		position: absolute;
		right: 1.27rem;
		top: 0rem;
		padding: 0.1rem 0.2rem 0.3rem;
		z-index: 99;
		border: 1px dotted #0084ff;
		background: rgba(10, 24, 88, 0.8);
		box-shadow: 0px 0px 10px #0084ff inset;
		border-top-left-radius: 0.5rem;
		border-bottom-right-radius: 0.5rem;
	}

	.set_open li {
		border-bottom: 1px dotted #0084ff;
		font-size: 0.2rem;
		padding: 0.15rem 0.1rem;
		color: #00a6ff;
		min-width: 1.4rem;
	}

	.set_open input {
		appearance: none;
		-webkit-appearance: none;
		outline: none;
		width: 14px !important;
		height: 14px;
		text-align: center;
		line-height: 1;
		border: 1px solid #0084ff;
		border-radius: 2px;
	}

	.set_open label {
		cursor: pointer;
	}

	.set_open input::after {
		content: '\2714';
		color: transparent;
	}

	.set_open input:checked::after {
		color: #0084ff;
	}
}
</style>